import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import HeaderLayout from "../../layouts/HeaderLayout/HeaderLayout";
import Button from "../../components/Button";

import TDCXLogo from "../../components/_Icons/TDCXLogo";
import FlashCoachLogo from "../../components/_Icons/FlashCoachLogo";
import ExpiredLinkLogo from "./icons/ExpiredLinkLogo";

import styles from "./LinkExpired.module.scss";

export default function LinkExpired(props) {
  const history = useHistory();
  const { t } = useTranslation();

  const handleRedirect = () => {
    history.push("/");
  };

  return (
    <HeaderLayout
      headerContent={
        <div className={styles.headerLogo} onClick={handleRedirect}>
          <FlashCoachLogo />
        </div>
      }
    >
      <div className={styles.contentWrapper}>
        <div className={styles.logo}>
          <ExpiredLinkLogo />
        </div>
        <div className={styles.textWrapper}>
          <h6>{t("changePassword.linkExpired")}</h6>
          <span className={styles.subtitle}>
            {t("changePassword.linkExpiredMessage")}
          </span>
          <Button
            className={styles.button}
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleRedirect}
          >
            {t("changePassword.backToLogin")}
          </Button>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.logo}>
          <TDCXLogo width={100} />
        </div>
        <div className={styles.copyright}>{t("common.copyright")}</div>
      </div>
    </HeaderLayout>
  );
}
